export default {
    doctor: [],
    sales: [],
    manager: [],
};
